import { render, staticRenderFns } from "./NeedSocialUnit.vue?vue&type=template&id=6fbcf1f4&scoped=true"
import script from "./NeedSocialUnit.vue?vue&type=script&lang=js"
export * from "./NeedSocialUnit.vue?vue&type=script&lang=js"
import style0 from "./NeedSocialUnit.vue?vue&type=style&index=0&id=6fbcf1f4&prod&lang=css"
import style1 from "./NeedSocialUnit.vue?vue&type=style&index=1&id=6fbcf1f4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbcf1f4",
  null
  
)

export default component.exports